import React, { FC } from 'react';
import styled from 'styled-components';
import {
    SkeletonBlock,
    SkeletonLeftSidebar,
    SkeletonLeftSidebarContent,
    SkeletonLeftSidebarLayout,
    SkeletonPageHeader,
    SkeletonPageShell,
    SkeletonRow,
    SkeletonStack
} from 'src/components/widgets/skeleton';

const DraftConfigurationsSkeletonShell = styled(SkeletonPageShell)``;

const DraftConfigurationsSkeletonHeader = styled(SkeletonPageHeader)``;

const DraftConfigurationsSkeletonLayout = styled(SkeletonLeftSidebarLayout)``;

const DraftConfigurationsSidebarSkeleton = styled(SkeletonLeftSidebar)``;

const DraftConfigurationsToolbarSkeleton = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    min-width: 0;

    @media (max-width: 700px) {
        align-items: stretch;
        flex-direction: column;
    }
`;

const DraftConfigurationsGridSkeleton = styled.div`
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 18px;
    min-width: 0;

    @media (max-width: 1200px) {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    @media (max-width: 700px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
`;

const DraftConfigurationsCardSkeleton = styled.div`
    border: 1px solid ${(props) => props.theme.app.borderColor};
    border-radius: 8px;
    background: #ffffff;
    padding: 12px;
    min-width: 0;
`;

export const DraftConfigurationsPageSkeleton: FC = () => (
    <DraftConfigurationsSkeletonShell aria-hidden='true'>
        <DraftConfigurationsSkeletonHeader>
            <SkeletonStack $gap='8px' $flex='1'>
                <SkeletonBlock $width='min(240px, 100%)' $height='26px' />
                <SkeletonBlock $width='min(430px, 100%)' $height='13px' />
            </SkeletonStack>
        </DraftConfigurationsSkeletonHeader>
        <DraftConfigurationsSkeletonLayout>
            <DraftConfigurationsSidebarSkeleton>
                <SkeletonStack $gap='14px'>
                    <SkeletonBlock $width='45%' $height='16px' />
                    <SkeletonBlock $height='36px' $radius='6px' />
                    {Array.from({ length: 7 }).map((_, index) => (
                        <SkeletonRow key={index} $gap='10px'>
                            <SkeletonBlock $width='24px' $height='24px' $round />
                            <SkeletonBlock $width={index % 2 === 0 ? '68%' : '52%'} $height='13px' />
                        </SkeletonRow>
                    ))}
                </SkeletonStack>
            </DraftConfigurationsSidebarSkeleton>
            <SkeletonLeftSidebarContent>
                <SkeletonStack $gap='18px'>
                    <DraftConfigurationsToolbarSkeleton>
                        <SkeletonBlock $width='min(280px, 100%)' $height='38px' $radius='6px' />
                        <SkeletonBlock $width='160px' $height='32px' $radius='6px' />
                    </DraftConfigurationsToolbarSkeleton>
                    <DraftConfigurationsGridSkeleton>
                        {Array.from({ length: 10 }).map((_, index) => (
                            <DraftConfigurationsCardSkeleton key={index}>
                                <SkeletonStack $gap='10px'>
                                    <SkeletonBlock $height='150px' $radius='6px' />
                                    <SkeletonBlock $width={index % 2 === 0 ? '78%' : '62%'} $height='15px' />
                                    <SkeletonBlock $width='48%' $height='12px' />
                                </SkeletonStack>
                            </DraftConfigurationsCardSkeleton>
                        ))}
                    </DraftConfigurationsGridSkeleton>
                </SkeletonStack>
            </SkeletonLeftSidebarContent>
        </DraftConfigurationsSkeletonLayout>
    </DraftConfigurationsSkeletonShell>
);
